import {DetailCargo} from "~/apps/packages/cargos/queries";
import {Grid} from "@mui/material";
import {CargoListItem} from "~/apps/packages/cargos/components/CargoList/CargoListItem";
import React from "react";


export type CargoDetailInfoProps = {
    cargo: DetailCargo
}

export const CargoDetailInfo = (props: CargoDetailInfoProps) => {
    const {cargo} = props;

    return (
        <Grid container direction="column" rowSpacing="8px" wrap="nowrap" paddingY={2}>
            <Grid item>
                <CargoListItem cargo={cargo} disableDetailButton={true}/>
            </Grid>
            {/*{cargo.arrival && (*/}
            {/*    <>*/}
            {/*        <Grid item>*/}
            {/*            <Typography variant="screenText" color="primary">*/}
            {/*                Прибытие*/}
            {/*            </Typography>*/}
            {/*        </Grid>*/}
            {/*        <Grid item>*/}
            {/*            <Card>*/}
            {/*                <CardContent>*/}
            {/*                    <TypographyWithLabel label={cargo.arrival.document.type}>*/}
            {/*                        {cargo.arrival.document.number} от {moment(cargo.arrival.document.date).format("DD MMM YYYY")}*/}
            {/*                    </TypographyWithLabel>*/}
            {/*                </CardContent>*/}
            {/*            </Card>*/}
            {/*        </Grid>*/}
            {/*    </>*/}
            {/*)}*/}
            {/*{cargo.departure && (*/}
            {/*    <>*/}
            {/*        <Grid item>*/}
            {/*            <Typography variant="screenText" color="primary">*/}
            {/*                Убытие*/}
            {/*            </Typography>*/}
            {/*        </Grid>*/}
            {/*        <Grid item>*/}
            {/*            <Card>*/}
            {/*                <CardContent>*/}
            {/*                    <TypographyWithLabel label={cargo.departure.document.type}>*/}
            {/*                        {cargo.departure.document.number} от {moment(cargo.departure.document.date).format("DD MMM YYYY")}*/}
            {/*                    </TypographyWithLabel>*/}
            {/*                </CardContent>*/}
            {/*            </Card>*/}
            {/*        </Grid>*/}
            {/*    </>*/}
            {/*)}*/}
        </Grid>
    )
}